'use strict';

import ready from './lib/ready';
import promiseIdle from './lib/promise-idle';
import promiseLoaded from './lib/promise-loaded';
import {delegate} from './lib/events';

import 'script-loader!tarteaucitronjs';

// comment that line to enable dynamic language loading on i18n sites
//import 'script-loader!tarteaucitronjs/lang/tarteaucitron.fr';

window.tac && (function iife(tarteaucitron, opts, fallback) {
    ready()
        // loading after window.load event so TaC won’t automatically load itself
        .then(promiseLoaded())
        .then(promiseIdle())
        .then(function () {
            if (tarteaucitron.lang.reload) {
                // language loaded already
                return;
            }
            if (!opts.lang_url) {
                throw new Error('Unable to load TaC lang file.');
            }
            return loadScript(opts.lang_url);
        })
        .then(function init() {
            tarteaucitron.init(opts.params);
            for (const prop in fallback) {
                tarteaucitron[prop] = fallback[prop];
            }

            reload();
            document.addEventListener('barba/after', reload);

            // manually load TaC
            tarteaucitron.initEvents.loadEvent(false);

            // add listeners on TaC service buttons for async page loads
            document.addEventListener('click', function (e) {
                const button = e.target.closest('button.tarteaucitronAllow');
                button && tarteaucitron.userInterface.respond(button, true);
            });

            // add listener for cookie management links
            document.addEventListener('click', delegate('[href="#cookies"]', function (e) {
                e.preventDefault();
                tarteaucitron.userInterface.openPanel();
                return false;
            }));
        });

    function reload() {
        addManagementLink();

        document.querySelectorAll('[href="#cookies"]').forEach(function (link) {
            link.setAttribute('role', 'button');
        });

        // refresh services only once by service
        Array.prototype.reduce.call(document.querySelectorAll('[data-tac-service]'), function (services, node) {
            services.add(node.getAttribute('data-tac-service'));
            return services;
        }, new Set()).forEach((service) => {
            tarteaucitron.job.push(service);
        });
    }

    function addManagementLink() {
        // add cookie management link
        if (!opts.management_selector) {
            console.error('Backend must provide a “translation” object with a “management_selector” key');
            return;
        }
        var menu = document.querySelector(opts.management_selector);
        if (!menu) {
            console.error('Cookie management menu not found (selector was “' + opts.management_selector + '”)');

            return;
        }

        var item = document.createElement('li');
        menu.appendChild(item);
        item.setAttribute('class', item.previousElementSibling.getAttribute('class'));
        var link = document.createElement('a');
        link.appendChild(document.createTextNode(opts.management_label));
        link.setAttribute('href', '#cookies');
        link.setAttribute('role', 'button');
        item.appendChild(link);
    }

    function loadScript(url) {
        return new Promise(function (resolve, reject) {
            var script = window.document.createElement('script');
            script.src = url;
            script.async = true;
            script.onload = function () {
                script.remove();
                resolve();
            };
            script.onerror = function () {
                script.remove();
                reject();
            };
            window.document.head.appendChild(script);
        });
    }

})(window.tarteaucitron, window.tac.opts, window.tac.fallback);
